import SubNavActions from './SubNavActions';

export default SubNavActions;
